import { createEffect, type Component, type JSX } from "solid-js"
import { getCanvas2dContext } from "../../lib/canvas/get_canvas_2d_context"
import playerColorToHex from "../../lib/core/player/playerColorToHex"
import leadingDebounce from "../../lib/ldsh/leadingDebounce"

interface ColorPair {
  color1: number
  color2: number
}

interface Props {
  value: ColorPair
  width: number
  height: number
  style?: JSX.CSSProperties
}

const PlayerColorsBar: Component<Props> = (props) => {
  return (
    <canvas
      ref={(canvasElem) => {
        const draw = leadingDebounce((color1: number, color2: number, width: number, height: number) => {
          const ctx = getCanvas2dContext(canvasElem)
          if (ctx) {
            canvasElem.width = width
            canvasElem.height = height

            const halfWidth = width / 2

            ctx.fillStyle = playerColorToHex(color1)
            ctx.fillRect(0, 0, halfWidth, height)

            ctx.fillStyle = playerColorToHex(color2)
            ctx.fillRect(halfWidth, 0, halfWidth, height)
          }
        }, 100)

        createEffect(() => {
          // eslint-disable-next-line solid/reactivity
          const { width, height, value } = props
          const { color1, color2 } = value
          draw(color1, color2, width, height)
        })
      }}
      style={props.style}
    />
  )
}

export default PlayerColorsBar
